import React, { useState } from "react";
import PropTypes from 'prop-types';
import Checkbox from '@components/common/checkbox/main';

function ActionSelection({
  actionableKeys,
  updateActionableKeys,
  actionableResources,
  ruleType,
  allSelected,
  handleSelectAll
}) {
  const [actionableSearch, updateActionableSearch] = useState('');
  const renderActionableSearch = () => {
    const hideCloseClass = actionableSearch === '' ? 'hide-close' : '';
    return (
      <div className="add-resource-search-container">
        <span className="icon bff-search" />
        <span
          className={`icon bff-close ${hideCloseClass}`}
          onClick={() => updateActionableSearch('')}
        />
        <input
          className="inputs add-resource-search"
          type="text"
          value={actionableSearch}
          onChange={(e) => { updateActionableSearch(e.target.value); }}
          placeholder={t("Search")}
        />
      </div>
    );
  };

  const actionableType = () => {
    if (ruleType.includes("CollectionAssociation")) {
      return "Collection";
    }
    if (ruleType.includes("LabelAssociation")) {
      return "Label";
    }
    if (ruleType.includes("SectionAssociation")) {
      return "Section";
    }
    return undefined;
  };

  const handleActionableUpdates = (key) => {
    let selections = new Set(actionableKeys);
    if (actionableType() === "Section") {
      selections = new Set([key]); // can only select 1
    } else if (selections.has(key)) {
      selections.delete(key);
    } else {
      selections.add(key);
    }
    updateActionableKeys([...selections]);
  };

  const formattedCheckboxes = () => {
    const sortedResources = [...actionableResources].sort((a, b) => {
      if (a.attributes.name.toUpperCase() > b.attributes.name.toUpperCase()) {
        return 1;
      }
      if (b.attributes.name.toUpperCase() > a.attributes.name.toUpperCase()) {
        return -1;
      }
      return 0;
    });
    const displayedActionables = [];

    for (let i = 0; i < sortedResources.length; i += 1) {
      const resource = sortedResources[i];
      const displayResource = resource.attributes.name.toUpperCase()
        .indexOf(actionableSearch.toUpperCase()) > -1;

      if (displayResource) {
        displayedActionables.push(
          <div className="checkbox-container" key={i}>
            <Checkbox
              checked={actionableKeys.indexOf(resource.id) > -1}
              labelHtml={<h5> {resource.attributes.name} </h5>}
              size="sm"
              toggle={() => handleActionableUpdates(resource.id)}
            />
          </div>
        );
      }
    }

    return displayedActionables;
  };

  const renderActionableList = () => {
    if (!actionableResources || actionableResources.length < 1) { return null; }

    const hideAllCheckbox = ruleType.includes("SectionAssociation") || actionableSearch.length;
    const selectAllCollectionsCheckbox = (
      <div className="checkbox-container" key="-1">
        <Checkbox
          size="sm"
          checked={allSelected}
          labelHtml={<h5> {t('All')}</h5>}
          toggle={() => handleSelectAll(!allSelected)}
        />
      </div>
    );

    const checkboxes = hideAllCheckbox
      ? [formattedCheckboxes()]
      : [selectAllCollectionsCheckbox, formattedCheckboxes()];

    return (
      <div className="resource-list-container fixed-height">
        { checkboxes }
      </div>
    );
  };

  return (
    <React.Fragment>
      <h3 className="resource-select-title">
        {`${t("Add to")} ${t(actionableType())}${actionableType() !== "Section" ? "s" : ""}`}
      </h3>
      {renderActionableSearch()}
      {renderActionableList()}
    </React.Fragment>
  );
}

ActionSelection.propTypes = {
  ruleType: PropTypes.string.isRequired,
  actionableResources: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      key: PropTypes.string
    })
  ).isRequired,
  actionableKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateActionableKeys: PropTypes.func.isRequired,
  allSelected: PropTypes.bool.isRequired,
  handleSelectAll: PropTypes.func.isRequired
};

export default ActionSelection;
